export default __webpack_public_path__ + "static/media/drawing-woman13-focusfill.7e00cd89.svg";